<template>
  <div>
    <h2 class="site-title">{{ title }}</h2>
    <v-stepper v-model="step" vertical>
      <v-stepper-step
        class="backable"
        :complete="step > 1"
        @click="setStep(1)"
        step="1"
      >
        {{ $t("steps.surface.label") }}
      </v-stepper-step>
      <v-stepper-content step="1">
        <surface @complete="arrange" v-if="step > 0"/>
      </v-stepper-content>

      <v-stepper-step :complete="step > 2" step="2">
        {{ $t("steps.editor.label") }}
      </v-stepper-step>
      <v-stepper-content step="2">
        <editor
          :arranged="!arranging && step > 1"
          @abort="step--"
          @complete="step++"
        />
      </v-stepper-content>

      <v-stepper-step :complete="step > 3" step="3">
        {{ $t("steps.presentation.label") }}
      </v-stepper-step>
      <v-stepper-content step="3">
        <presentation
          :offer="preparingOffer"
          :preparing="arranging"
          @abort="step = 1"
          @complete="prepareOffer"
        />
      </v-stepper-content>

      <v-stepper-step
        class="backable"
        :complete="step > 4"
        @click="setStep(4)"
        step="4"
      >
        {{ $t("steps.offer.label") }}
      </v-stepper-step>
      <v-stepper-content step="4">
        <offer @abort="step = 1" @complete="step++" />
      </v-stepper-content>

      <v-stepper-step
        class="backable"
        :complete="step > 5"
        @click="setStep(5)"
        step="5"
      >
        {{ $t("steps.customer.label") }}
      </v-stepper-step>
      <v-stepper-content step="5">
        <customer @abort="step--" @complete="step++" />
      </v-stepper-content>

      <v-stepper-step step="6">
        {{ $t("steps.summary.label") }}
      </v-stepper-step>
      <v-stepper-content step="6">
        <configurator-summary
          :key="summaryKey"
          @abort="step--"
          @save="saveOffer"
        />
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import Surface from "./steps/Surface";
import Presentation from "./steps/Presentation";
import Customer from "./steps/Customer";
import Summary from "./steps/Summary";
import Offer from "./steps/Offer";
import Editor from "@/components/steps/Editor";

export default {
  components: {
    Editor,
    Surface,
    Presentation,
    Customer,
    "configurator-summary": Summary,
    Offer,
  },
  props: {
    startStep: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      step: 0,
      arranging: false,
      summaryKey: 0,
      preparingOffer: false,
    };
  },
  computed: {
    configurator() {
      return this.$store.state.configurator;
    },
    title() {
      if (this.configurator.number) {
        return this.$t("orders.edit", { number: this.configurator.number });
      }

      return this.$t("nav.configurator-" + this.$store.state.system);
    },
  },
  methods: {
    setStep(value) {
      if (this.step > value) {
        this.step = value;
      }
    },
    arrange() {
      this.step++;
      this.arranging = true;
      this.$http
        .post("terrace/arrange", {
          surfaces: this.configurator.surfaces.map((surface) => {
            return {
              points: surface.points.map((point) => {
                return {
                  x: point.x * surface.scale,
                  y: point.y * surface.scale,
                };
              }),
              entrance: surface.entrance,
              algorithm: surface.algorithm,
              joist_id: surface.joist,
              plank_id: surface.plank,
              slat_id: surface.slat,
              height: surface.height,
              scale: surface.scale,
              surface_id: surface.surface,
            };
          }),
        })
        .then(({ data }) => {
          this.$store.commit("setArrangedData", data);
          this.$store.dispatch("requestProjects");
          this.arranging = false;
        })
        .catch(() => {
          this.arranging = false;
        });
    },
    prepareOffer() {
      this.preparingOffer = true;
      this.$store
        .dispatch("prepareOffer")
        .then(() => {
          this.preparingOffer = false;
          this.step++;
        })
        .catch(() => {
          this.preparingOffer = false;
        });
    },
    saveOffer() {
      let payload = this.$store.getters.configuratorPayload;
      let request =
        payload.id > 0
          ? this.$http.put("orders/" + payload.id, payload)
          : this.$http.post("orders", payload);
      request
        .then((response) => {
          alert("Oferta zapisana");
          this.$store.commit("cleanConfigurator");
          this.$router.push({
            name: "Order View",
            params: { id: response.data.id },
          });
        })
        .catch(() => {
          alert("Błąd przy zapisywaniu oferty");
        });
    },
  },
  mounted() {
    this.step = this.startStep;
  },
  watch: {
    step(val) {
      if (val === 6) {
        this.summaryKey++;
      }
      this.$store.commit('setCurrentStep', val)
    },
  },
};
</script>

<style>
.backable.v-stepper__step--complete:hover .v-stepper__label {
  text-decoration: underline;
  cursor: pointer;
}
</style>
